module.exports = __webpack_public_path__ + "img/banner1.362793bf.png";